exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cpd-list-card[data-v-42086993]  .v-toolbar__title{font-size:18px;font-weight:500}.cpd-table[data-v-42086993]  .v-data-table-header th{font-size:12px;font-weight:600}.cpd-table[data-v-42086993]  tbody td{font-size:12px}", ""]);

// exports
